var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResync(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3098 2.55212C15.655 2.55212 15.9348 2.83195 15.9348 3.17712V6.71266C15.9348 7.05784 15.655 7.33766 15.3098 7.33766H11.7743C11.4291 7.33766 11.1493 7.05784 11.1493 6.71266C11.1493 6.36748 11.4291 6.08766 11.7743 6.08766H13.7413C11.3701 4.21843 7.9221 4.37765 5.73441 6.56534C3.37499 8.92476 3.37499 12.7501 5.73441 15.1096C8.09382 17.469 11.9192 17.469 14.2786 15.1096C15.8593 13.5288 16.3818 11.2898 15.8431 9.27234C15.754 8.93885 15.9522 8.5963 16.2857 8.50724C16.6192 8.41818 16.9617 8.61633 17.0508 8.94983C17.6999 11.3806 17.0715 14.0844 15.1625 15.9934C12.3149 18.841 7.6981 18.841 4.85052 15.9934C2.00295 13.1459 2.00295 8.52903 4.85052 5.68146C7.54387 2.98811 11.82 2.84224 14.6848 5.24384V3.17712C14.6848 2.83195 14.9646 2.55212 15.3098 2.55212Z",
    fill: "#662D91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResync);
export default __webpack_public_path__ + "static/media/resync.910559cf20c1c7869fe181f2a35f00eb.svg";
export { ForwardRef as ReactComponent };